export default __webpack_public_path__ + "static/media/38_mobile.6280c68f.jpeg";